module.exports = __webpack_public_path__ + "img/whatsapp.0c1f8d2b.png";